import { WebhookStatus } from '@/types/events';

export const WEBHOOK_STATUSES: {
  value: WebhookStatus;
  label: string;
  color: string;
}[] = [
  { value: 'succeeded', label: 'Succeeded', color: 'green' },
  { value: 'failed', label: 'Failed', color: 'red' },
  { value: 'scheduled', label: 'Scheduled', color: 'yellow' },
  { value: 're_scheduled', label: 'Rescheduled', color: 'yellow' },
  { value: 'not_configured', label: 'Not Configured', color: 'gray' },
  { value: 'not_applicable', label: 'Not Applicable', color: 'gray' },
  { value: 'skipped', label: 'Skipped', color: 'gray' },
];

export function formatWebhookStatus(status: string): string {
  const found = WEBHOOK_STATUSES.find((s) => s.value === status);
  return found?.label ?? status;
}

export function getWebhookStatusColor(status: string): string {
  const found = WEBHOOK_STATUSES.find((s) => s.value === status);
  return found?.color ?? 'gray';
}
